/* import __COLOCATED_TEMPLATE__ from './seller-profile-services.hbs'; */
import Component from '@glimmer/component';
import clsx from 'clsx';

const CLASS_NAME = 'GLM-c-seller-profile-services';

class SellerProfileServices extends Component {
  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
    );
  }

  get className() {
    return CLASS_NAME;
  }

  /** @type {Service[]} */
  get verifiedServices() {
    return this.args.user.services.filter(({ verified }) => verified);
  }

  /** @type {Service[]} */
  get notVerifiedServices() {
    return this.args.user.services.filter(({ verified }) => !verified);
  }
}

export default SellerProfileServices;
